export class ScrollPageStep {
  run(navigationInstruction, next) {
    const pageHostElement = document.querySelector('#main-page-host .simplebar-content-wrapper');
    if (pageHostElement) {
      pageHostElement.scrollTop = 0;
    }
    return next();
  }
}